import React, {useEffect, useRef, useState} from 'react';
import CardHeader from '../../components/common/card-header/CardHeader';
import {
    FlexItem,
    FlexLayout,
    StackLayout, Text, Card, Spinner
} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';
import '../CommonCard.css';
import Constants from '../../components/common/Constants';
import FirstTimeLogInSetupForm from "./FirstTimeLogInSetupForm";
import CardAlert from "../../components/common/card-alert/CardAlert";
import {useIntl} from "react-intl";
import {useLocation, useNavigate} from 'react-router';

function FirstTimeLogInSetup() {
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Due to consecutive incorrect attempts your account has been locked, you must reset your password to proceed.\n" +
        "                                You can reset your password online through Forgot Password.");
    const[isLoading, setIsLoading] = useState(false);

    const showErrorOnPage = (error) => {
        setErrorMessage(error);
        setHasError(true);
    }
    const navigate = useNavigate();
    const location = useLocation();
    const intl = useIntl()
    const mainRef = useRef(null);

    useEffect(() => {
        document.title = intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.step1.page.title'});
        // Set focus to main element for screen reader announcement
        if (mainRef.current) {
            mainRef.current.focus();
        }

        const expectedPreviousPage = Constants.login;
        if (location.state?.from !== expectedPreviousPage) {
            navigate('/');
        }
        }, [intl,location,navigate]);

    return (
        <main ref={mainRef} role="main" aria-label="First Time Log In Setup" tabIndex="-1">
            <FlexLayout className={"page-content"}>
                {isLoading ? (
                    <FlexItem className="spinner-wrapper">
                        <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
                    </FlexItem>
                ) : (
                    <FlexItem  className={`error-wrapper ${hasError ? 'visible' : ''}`}>
                        <div>
                            <CardAlert status={"error"} setHasError={setHasError}>
                                {errorMessage}
                            </CardAlert>
                        </div>
                    </FlexItem>
                )}
                <FlexItem>
                    <Card className={"card-wrapper"}>
                        <FlexItem className="card-content">
                            <StackLayout gap={2}>

                                <CardHeader style={{maxWidth: '21rem'}} heading={Constants.firstTimeLogInSetupTitle}
                                            subheading={Constants.firstTimeLogInSetupStep1Title}/>

                                <StepTracker label1={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step1'})} step1="active"
                                             label2={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step2'})} step2="pending"
                                             label3={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step3'})} step3="pending"/>
                                <FlexItem>
                                    <Text>
                                        {Constants.firstTimeLogInSetupStep1InstructionalText}
                                    </Text>
                                </FlexItem>
                                <FirstTimeLogInSetupForm data-testid="first-time-login-setup-form" showErrorOnPage={showErrorOnPage}
                                    isLoading={isLoading} setIsLoading={setIsLoading}
                                />
                            </StackLayout>
                        </FlexItem>
                    </Card>
                </FlexItem>
            </FlexLayout>
        </main>
    );
}

export default FirstTimeLogInSetup;